/** Convert Stripe product data to a token package */
export function convertStripeProductToCreditPackage(product) {
  return {
    id: product.id,
    name: product.name,
    tokenAmount: product.tokenAmount,
    // The price comes from Stripe in cents as a string
    priceInCents: parseFloat(product.price.price),
    badge: product.badge
  };
}